import { huitabSettings } from '../../services/settings-loader';
import MicroApp from './micro-app-base';

/**
 * Microapp widget coupures
 */
export default class WidgetAideEtContactMicroApp extends MicroApp {
  /**
   * Initialise une nouvelle instance de type {@type WidgetAideEtContactMicroApp}.
   */
  constructor() {
    super();
    this.url = huitabSettings.url.widget_interlocuteurs_url;
    this.urlVie = huitabSettings.url.widget_interlocuteurs_url_vie;
  }
}
